import React from 'react';

export default function Tank21Icon({
  width = 64,
  height = 96,
  startColor = '#1E1E1E',
  midColor = '#EBEBEB',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 74.908 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_BackLegs">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="12.7961" y1="91.4385" x2="17.3274" y2="91.4385">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#5B5B5B"}} />
		<stop offset="0.77" style={{stopColor: "#585858"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M12.796,77.576v26.658c0,0,0.533,1.066,2.398,1.066c1.51,0,2.133-1.066,2.133-1.066V79.176   L12.796,77.576z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="57.3147" y1="91.4385" x2="62.1125" y2="91.4385">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#5B5B5B"}} />
		<stop offset="0.77" style={{stopColor: "#585858"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M62.113,77.576v26.658c0,0-0.721,1.066-2.398,1.066c-1.729,0-2.399-1.066-2.399-1.066V79.176   L62.113,77.576z" />
</g>
<g id="Group_TankBody">
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="48.1855" x2="74.9084" y2="48.1855">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M74.908,64.514V6.133H0v58.38c0,0,11.463,25.725,37.321,25.725   C64.068,90.238,74.908,64.514,74.908,64.514z" />
	
		<radialGradient id={`${id}_4_`} cx="37.4543" cy="77.9766" r="28.1428" gradientTransform="matrix(1 0 0 1.3 0 -23.393)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.14" style={{stopColor: "#DCDCDC"}} />
		<stop offset="0.4" style={{stopColor: "#B7B7B7"}} />
		<stop offset="0.75" style={{stopColor: "#7B7B7B"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_4_)`} d="M74.908,65.313v-0.8c0,0-5.454,4.82-29.856,6.132c-3.727,0.2-11.2,0.156-14.929,0   C8.788,69.75,0,64.514,0,64.514v0.8c0,0,3.253,26.125,37.588,26.125C72.192,91.438,74.908,65.313,74.908,65.313z" />
	<ellipse fill="#7E7E7E" cx="37.322" cy="6.133" rx="37.32" ry="6.131" />
</g>
<g id="Group_FrontLegs">
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="4.5315" y1="91.4385" x2="11.4631" y2="91.4385">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M4.531,70.379v40.52c0,0,0.642,1.6,3.466,1.6c2.52,0,3.466-1.6,3.466-1.6V79.709   c0,0-0.065-3.291-2.134-6.459C7.454,70.379,4.531,70.379,4.531,70.379z" />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="63.178" y1="91.4385" x2="70.1106" y2="91.4385">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_6_)`} d="M70.111,70.379v40.52c0,0-1.125,1.6-3.466,1.6c-2.284,0-3.466-1.6-3.466-1.6V79.709   c0,0-0.085-3.142,1.9-5.959C67.454,70.379,70.111,70.379,70.111,70.379z" />
</g>
    
      </g>
      <rect x="0" y="0" width="74.908" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
